jQuery(function ($) {
    logo();
    botonReserva();
    opinion();
    efectoScroll();
    carrusel();


    function carrusel(){
        $('.owl-carousel2').owlCarousel({
            autoWidth:true,
            autoplay:false,
            items:5,
            autoplayTimeout:5000,
            autoplayHoverPause:true,
            responsiveClass:true,
            navContainer: false,
            nav: false,
            dots:false,
            margin: 35,
            navRewind: true,
            responsive:{
                0:{
                    items:2,
                    nav:false
                },
                300:{
                    items:5,
                    nav:false
                },
                600:{
                    items:6,
                    nav:false
                },
                900:{
                    items:8,
                    nav:false
                }
            }
        })
    }

    function inicializar_mapa() {

        var mapOptions = {
            center: new google.maps.LatLng(37.094966, -3.398687),
            zoom: 15,
            scrollwheel: false,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: [
                {
                    "featureType": "all",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "on"
                        },
                        {
                            "hue": "#1b7247"
                        }
                    ]
                }
            ]

        };
        var locations = [
            ['Calle Pradollano, s/n,18196 Granada',37.094966, -3.398687, 1]
        ];

        if ($("#mapa_div").length) {
            var map = new google.maps.Map(document.getElementById("mapa_div"), mapOptions);

            var infowindow = new google.maps.InfoWindow();

            var marker, i;

            for (i = 0; i < locations.length; i++) {
                marker = new google.maps.Marker({
                    position: new google.maps.LatLng(locations[i][1], locations[i][2]),
                    map: map,
                    icon:"images/map-marker.png"

                });

                google.maps.event.addListener(marker, 'click', (function(marker, i) {
                    return function() {
                        infowindow.setContent(locations[i][0]);
                        infowindow.open(map, marker);
                    }
                })(marker, i));
            }
        }
    }
    function efectoScroll(){
        //efecto scroll
        $('a.scroll').click(function(e){
            e.preventDefault();
            $('html, body').stop().animate({scrollTop: $($(this).attr('href')).offset().top}, 1000);
        });
    }
    function opinion(){
        $('.oNPrados').hide();
        $('.verNPrados').on('click',function(e){
            e.preventDefault();
            $( ".oNPrados" ).toggle( "slow", function() {
                if( $('.oNPrados').is(":hidden") ){
                    $(".verNPrados").text('Ver mÃ¡s');
                }else{
                    $(".verNPrados").text('Ver menos');
                }
            });
        });

        $('.oGarijo').hide();
        $('.verGarijo').on('click',function(e){
            e.preventDefault();
            $( ".oGarijo" ).toggle( "slow", function() {
                if( $('.oGarijo').is(":hidden") ){
                    $(".verGarijo").text('Ver mÃ¡s');
                }else{
                    $(".verGarijo").text('Ver menos');
                }
            });
        });
        $('.DTorres').hide();
        $('.verDTorres').on('click',function(e){
            e.preventDefault();
            $( ".DTorres" ).toggle( "slow", function() {
                if( $('.DTorres').is(":hidden") ){
                    $(".verDTorres").text('Ver mÃ¡s');
                }else{
                    $(".verDTorres").text('Ver menos');
                }
            });
        });
    }

    function logo(){
        if ($("header").hasClass('in-place')){
            $(".capaLogo img").hide();
            $(".capaLogo p").show();
        }else{
            $(".capaLogo img").show();
            $(".capaLogo p").hide();
        }
        $(window).scroll(function(){
            if ($("header").hasClass('in-place')){
                $(".capaLogo img").hide();
                $(".capaLogo p").show();
            }else{
                $(".capaLogo img").show();
                $(".capaLogo p").hide();
            }
        });
    }

    function calculoPrecioTotal(){
        precioTotal = 0;

        let inscripcionesprecios = {
            "congresista" : 710,
            "congresistareducida" : 510,
            "acompanante" : 645,
            "acompanantereducida" : 415,
        };
        cuotaCongresista = $("#cuotaCongresista").val();
        if(cuotaCongresista == "1-congresista"){
            precioTotal = inscripcionesprecios["congresista"];
        }
        if(cuotaCongresista == "1-congresistareducida"){
            precioTotal = inscripcionesprecios["congresistareducida"];
        }

        cuotaAcompanante = $("#cuotaAcompanante").val();
        if(cuotaAcompanante == "1-acompanante"){
            precioTotal = precioTotal + inscripcionesprecios["acompanante"] ;
        }else if(cuotaAcompanante == "2-acompanante"){
            precioTotal = precioTotal + (2 * inscripcionesprecios["acompanante"]);
        }else if(cuotaAcompanante == "3-acompanante"){
            precioTotal = precioTotal + (3 * inscripcionesprecios["acompanante"]);
        }else if(cuotaAcompanante == "4-acompanante"){
            precioTotal = precioTotal + (4 * inscripcionesprecios["acompanante"]);
        }else if(cuotaAcompanante == "5-acompanante"){
            precioTotal = precioTotal + (5 * inscripcionesprecios["acompanante"]);
        }

        cuotaAcompananteReducida = $("#cuotaAcompananteReducida").val();
        if(cuotaAcompananteReducida == "1-acompanantereducida"){
            precioTotal = precioTotal + inscripcionesprecios["acompanantereducida"];
        }else if(cuotaAcompananteReducida == "2-acompanantereducida"){
            precioTotal = precioTotal + (2 * inscripcionesprecios["acompanantereducida"]);
        }else if(cuotaAcompananteReducida == "3-acompanantereducida"){
            precioTotal = precioTotal + (3 * inscripcionesprecios["acompanantereducida"]);
        }else if(cuotaAcompananteReducida == "4-acompanantereducida"){
            precioTotal = precioTotal + (4 * inscripcionesprecios["acompanantereducida"]);
        }else if(cuotaAcompananteReducida == "5-acompanantereducida"){
            precioTotal = precioTotal + (5 * inscripcionesprecios["acompanantereducida"]);
        }


        $('#ins_totalprecio').val(precioTotal);
    }


    function ins_tipoPago(){
        if ($("input[name='ins_pago']:checked").attr("id")==="ins_pagoTransferencia") {
            $(".ins_textoTransferencia").show();
            $(".ins_textoTarjeta").hide();
        }else  if ($("input[name='ins_pago']:checked").attr("id")==="ins_pagoTarjeta") {
            $(".ins_textoTransferencia").hide();
            $(".ins_textoTarjeta").show();
        }
        $("input[name=ins_pago]:radio").change(function () {
            if ($("input[name='ins_pago']:checked").attr("id")==="ins_pagoTransferencia") {
                $(".ins_textoTransferencia").show();
                $(".ins_textoTarjeta").hide();
            }else  if ($("input[name='ins_pago']:checked").attr("id")==="ins_pagoTarjeta") {
                $(".ins_textoTransferencia").hide();
                $(".ins_textoTarjeta").show();
            }
        })
    }

    /*RESERVA*/
    function botonReserva(){
        $(".res_div").on('click', '.res_cerrarFormulario', function(){
            $("#res_form").hide();
        });
        $("#res_form").hide();
        $(".botonReserva").click(function(event) {
            $("#res_form").remove();
            $(".respuestaReserva").remove();
            $.ajax({
                type: "get",
                url: "modulos/formulario_reserva.php",
                success: function(data2) {
                    $(".res_div .container").fadeIn(1000).append(data2);
                    res_tipoPago();
                    $('#res_captchaOperation').html([numeroRandom(1, 10), '+', numeroRandom(1, 10), '='].join(' '));
                    reserva();
                    $("#bontonReservaOculto").click();
                }
            })
        });
    }

    function res_tipoPago(){
        if ($("input[name='res_pago']:checked").attr("id")==="res_pagoTransferencia") {
            $(".res_textoTransferencia").show();
            $(".res_textoTarjeta").hide();
        }else  if ($("input[name='res_pago']:checked").attr("id")==="res_pagoTarjeta") {
            $(".res_textoTransferencia").hide();
            $(".res_textoTarjeta").show();
        }
        $("input[name=res_pago]:radio").change(function () {
            if ($("input[name='res_pago']:checked").attr("id")==="res_pagoTransferencia") {
                $(".res_textoTransferencia").show();
                $(".res_textoTarjeta").hide();
            }else  if ($("input[name='res_pago']:checked").attr("id")==="res_pagoTarjeta") {
                $(".res_textoTransferencia").hide();
                $(".res_textoTarjeta").show();
            }
        })
    }
    function calendarios(){




        $('#fechaComienzo').datepicker({
            format: 'dd/mm/yyyy',
            language: 'es',
            startDate: "01/01/2024",
            endDate: "28/02/2024",

            todayHighlight: true
        }).on('changeDate', function(e) {
            // Revalidate the date field
            calculanoche();

        });

        $('#fechaFin').datepicker({
            format: 'dd/mm/yyyy',
            language: 'es',
            startDate: "01/01/2024",
            endDate: "28/02/2024",
            todayHighlight: true
        }).on('changeDate', function(e) {
            // Revalidate the date field
            calculanoche();

        });

        $(".res_div").on('change', '#num-melia-dui, #num-melia-doble', function(){
            $("#totalhabitaciones").val( parseFloat($("#num-melia-dui").val()) + parseFloat($("#num-melia-doble").val()) );
            $("#totalprecio").val( (parseFloat($("#num-melia-dui").val()).toFixed(2)*parseFloat(220.00).toFixed(2)) + (parseFloat($("#num-melia-doble").val()).toFixed(2)*parseFloat(270.00).toFixed(2)) );
            if($("#totalnoches").length && $("#totalnoches").val().length) {
                $("#totalprecio").val( parseFloat($("#totalnoches").val())*parseFloat($("#totalprecio").val()).toFixed(2) );
            }
        });
    }
    function calculanoche(){
        var fechaEntrada, fechaSalida;
        var oneDay = 24*60*60*1000;
        fechaEntrada = $('#fechaComienzo').datepicker("getDate");
        fechaSalida = $('#fechaFin').datepicker("getDate");
        if(fechaEntrada>fechaSalida){
            $("#totalnoches").val("");
        }else{
            var days   =  Math.round(Math.abs((fechaSalida - fechaEntrada)/(oneDay)));
            if(!isNaN(days)){
                if(days>0){
                    $("#totalnoches").val(days);
                    $("#totalprecio").val( (parseFloat($("#num-melia-dui").val()).toFixed(2)*parseFloat(220.00).toFixed(2)) + (parseFloat($("#num-melia-doble").val()).toFixed(2)*parseFloat(270.00).toFixed(2)) );
                    $("#totalprecio").val( parseFloat($("#totalnoches").val())*parseFloat($("#totalprecio").val()).toFixed(2) );
                }else{
                    $("#totalnoches").val("");
                }
            }
        }
    }


    function numeroRandom(min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min);
    }


    function sacarPrecio(numero){
        var res= numero.replace(".", "");
        res = res.split("-");
        return res[2].slice(0,-1);
    }
});